import { Component, TemplateRef, ViewChild, } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { Router, ActivatedRoute } from '@angular/router';
import DriverDTO from 'src/app/interfaces/driverDTO';
import { GeneralService } from 'src/app/services/general.service';
import { DriverService } from 'src/app/services/driver.service';
import { monitoringCellPhoneRequiredValidator } from 'src/app/directives/monitoringCellPhoneRequiredValidator';
import { monitorValidationCodeRequiredValidator } from 'src/app/directives/monitorValidationCodeRequiredValidator';
import { SmsService } from 'src/app/services/sms.service';

@Component({
     selector: 'app-driver-monitoring',
     templateUrl: './driver-monitoring.component.html',
     styleUrls: ['./driver-monitoring.component.scss'],
     standalone: false
})
export class DriverMonitoringComponent {
     userProfile?: UserProfile;
     // Get driver profile. Use driver.service.ts
     // Have on order-success.component and driver-dashboard.component
     driverProfile?: DriverDTO;
     isLoading = true;
     isSaving = false;
     sendText = false;
     addingSms = false;
     form!: FormGroup;
     showOutInMonitoringModal: boolean = false;
     validationCodeValue: string = '';
     theValidationCodeValue: string = '';
     waitingForCode: boolean = false;
     codesSentCount: number = 0;
     triesForCurrentCode: number = 0;
     maxTryCount: number = 3;
     verificationCodeInvalid: boolean = false;
     codeLength: number = 6;
     codeSent: boolean = false;
     isLockedOut: boolean = false;

     @ViewChild('ErrorSavingModal')
     errorSavingModal!: TemplateRef<any>;

     @ViewChild('OptOutInMonitoringModal')
     optOutInMonitoringModal!: TemplateRef<any>;

     constructor(private authenticationService: AuthenticationService,
          public service: DriverRecordRequestService,
          private router: Router,
          private driverService: DriverService,
          private modalService: NgbModal,
          private smsService: SmsService) {
     }

     ngOnInit(): void {
          this.scrollToTop();
          this.userProfile = this.authenticationService.getUserProfile();
          this.getDriverProfile();
     }

     getDriverProfile() {
          if (this.userProfile?.userData.email) {
               const driverProfilePromise = this.service.getDriverByUsername(this.userProfile.userData.email);
               driverProfilePromise.then((response: any) => {
                    if (response) {
                         this.driverProfile = response as DriverDTO;
                         this.createForm();
                    } else {
                         // Driver profile not found  
                         this.router.navigate(['/accessDenied']);
                    }
               });
          } else {
               this.authenticationService.logout();
          }
     }

     userEmail() {
          return this.driverProfile?.email;
     }

     cellPhoneDisplay() {
          let display = '';
          if (this.driverProfile?.altPhone && this.driverProfile.altPhone.length >= 10) {
               var numbers = this.driverProfile!.altPhone.replace(/\D/g, '');
               if (numbers.length >= 10) {
                    display = `(${numbers.substring(0, 3)}) ${numbers.substring(3, 6)}-${numbers.substring(6, 10)}`;
               }
          }
          return display;
     }

     createForm() {
          console.table(this.driverProfile)
          this.form = new FormGroup({
               enrolledInMonitoring: new FormControl(this.driverProfile?.isEnrolledInRecordChangeNotifications ?? false),
               enrolledInSms: new FormControl(this.driverProfile?.sendSmsMonitoringUpdates ?? false),
               cellPhoneNumber: new FormControl(this.driverProfile?.altPhone ?? '', [
                    Validators.pattern(/^\d{10}$/)
               ]),
               validationCode: new FormControl(this.validationCodeValue, [
                    Validators.maxLength(6),
                    // Validators.pattern(/^\d{6}$/)
               ])
          }, {
               validators: [
                    monitoringCellPhoneRequiredValidator,
                    monitorValidationCodeRequiredValidator
               ]
          });
          this.isLoading = false;
     }

     isEnrolledInMonitoring() {
          if (this.enrolledInMonitoring?.value && this.enrolledInMonitoring.value === true) {
               return true;
          }
          return false;
     }

     isEnrolledInSms() {
          if (this.enrolledInSms?.value && this.enrolledInSms.value === true && this.addingSms === false) {
               return true;
          }
          return false;
     }

     get enrolledInMonitoring() { return this.form!.get('enrolledInMonitoring'); }
     get enrolledInSms() { return this.form!.get('enrolledInSms') };
     get cellPhoneNumber() { return this.form!.get('cellPhoneNumber'); }
     get validationCode() { return this.form!.get('validationCode'); }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     showOptOutInMonitoringModal() {
          this.modalService.open(this.optOutInMonitoringModal, { ariaLabelledBy: 'optOutInMonitoringModalTitle' });
          this.showOutInMonitoringModal = true;
     }

     applyOptOutOfMonitoring() {
          this.form.patchValue({ enrolledInMonitoring: false });
          this.form.patchValue({ enrolledInSms: false });
          this.updateMonitoring();
     }

     updateMonitoring() {
          this.isSaving = true;
          this.mapFormToModel();
          const savePromise = this.driverService.updateMonitoring(this.driverProfile!);
          savePromise.subscribe((response: boolean | any) => {
               this.modalService.dismissAll()
               this.isSaving = false;
               if (response) {
                    console.log("save success")
                    if (this.enrolledInSms?.value && this.addingSms === false) {
                         this.form.patchValue({ validationCode: '' });
                         this.codesSentCount = 0;
                         this.triesForCurrentCode = 0;
                         this.smsService.sendStartSuccessMessage().subscribe();
                    }
               } else {
                    this.modalService.open(this.errorSavingModal, { ariaLabelledBy: 'errorSavingModalTitle' });
               }
          });
     }

     mapFormToModel() {
          this.driverProfile!.isEnrolledInRecordChangeNotifications = this.enrolledInMonitoring!.value;
          this.driverProfile!.sendSmsMonitoringUpdates = this.enrolledInSms!.value
          this.driverProfile!.altPhone = this.cellPhoneNumber!.value;
     }

     closeModal() {
          this.modalService.dismissAll();
     }

     showAddSms() {
          this.form.patchValue({ enrolledInSms: true });
          this.addingSms = true;
     }

     removeSms() {
          this.cancelAddSms();
          this.updateMonitoring();
     }

     cancelAddSms() {
          this.form.patchValue({ enrolledInSms: false });
          this.addingSms = false;
          this.waitingForCode = false;
          this.form.patchValue({ validationCode: '' });
     }

     startMonitoring() {
          this.form.patchValue({ enrolledInMonitoring: true });
          this.updateMonitoring();
     }

     verifyPhoneNumber() {
          if (this.isLockedOut){
               this.smsService.lockoutSms().subscribe();
               return;
          }
          this.codesSentCount = this.codesSentCount +1;
          this.triesForCurrentCode = 0;
          
          if (this.cellPhoneNumber?.valid && this.isLockedOut === false) {
               this.verificationCodeInvalid = false;
               this.waitingForCode = true;
               var verifyPromise = this.smsService.verifyPhoneNumber(this.cellPhoneNumber.value);
               verifyPromise.subscribe((response: boolean | any) => {
                    if (response) {
                         // wait for user to enter verification code
                    } else {
                         // An error occurred in the API
                         this.modalService.open(this.errorSavingModal, { ariaLabelledBy: 'errorModalTitle' });
                    }
               });
          }
     }

     testVerificationCode() {
          const validatePromise = this.smsService.validateVerificationCode(this.validationCode!.value);
          validatePromise.subscribe((response: boolean | any) => {
               if (response) {
                    // Verification code success. Confirmation text sent in web api.
                    this.waitingForCode = false;
                    this.addingSms = false;
                    this.triesForCurrentCode = 0;
                    this.codesSentCount = 0;
                    this.updateMonitoring();
               } else {
                    this.verificationCodeInvalid = true;
                    this.triesForCurrentCode = this.triesForCurrentCode +1;
                    if (this.triesForCurrentCode >= this.maxTryCount) {
                         this.isLockedOut = true;
                         this.smsService.lockoutSms().subscribe();
                    }
                    this.form.patchValue({ validationCode: '' });
               }
          });
     }

     clearInvalidError() {
          this.verificationCodeInvalid = false;
     }

     cellIsValid() {
          if (this.form!.errors) {

          }
          return this.form!.errors;
     }

     private generateRandomDigits(): string {
          // Generates a number from 0 to max number defined
          const max = 10 ** this.codeLength;
          const num = Math.floor(Math.random() * max);
          // Pads with leading zeros if the number is less than set number of digits
          return num.toString().padStart(this.codeLength, '0');
     }
}
